import React from 'react'
import { Toast } from 'react-bootstrap'

const AlertMessage = (props) => {

    return (
        <React.Fragment>
            <Toast onClose={() => props.setShow(false)} show={props.show} delay={2000} autohide className="wishRemoveToast text-white" bg="secondary">
                <Toast.Body>
                    {
                        props.reqType === "addCart" ?
                            "1 item successfully added to cart"
                            : props.reqType === "moveCart" ?
                                "1 item successfully moved to cart"
                                : props.reqType === "removeCart" ?
                                    "1 item removed from cart"
                                    : props.reqType === "addWished" ?
                                        "1 item successfully added to wishlist"
                                        : props.reqType === "moveWished" ?
                                            "1 item successfully moved to wishlist"
                                            : props.reqType === "removeWished" ?
                                                "1 item removed from wishlist"
                                                : ""
                    }
                </Toast.Body>
            </Toast>
        </React.Fragment>
    )
}

export default AlertMessage
